<a
  class="logo-link"
  aria-label="Go to the Home Captain home page"
  [routerLink]="routingService.homeUrl | async"
  [queryParams]="routingService.staticQueryParams | async"
>
  <img [src]="mediaService.LOGO_HEADER | async" alt="Home Captain logo" height="48px" />
</a>
